import { render, staticRenderFns } from "./newServiceBlocked.vue?vue&type=template&id=6d10f9a4&scoped=true"
import script from "./newServiceBlocked.vue?vue&type=script&lang=js"
export * from "./newServiceBlocked.vue?vue&type=script&lang=js"
import style0 from "./newServiceBlocked.vue?vue&type=style&index=0&id=6d10f9a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d10f9a4",
  null
  
)

export default component.exports